module.exports = __webpack_public_path__ + "img/word.ef7a41d6.png";